// frontend/src/components/chat/DirectoryList.tsx
import { Avatar } from '@roger/ui-components';
import { Users } from 'lucide-react';
import type { DirectoryRow } from '../../services/api';
import { initialsOf } from './initials';

interface DirectoryListProps {
  rows: DirectoryRow[];
  highlightedIndex: number;
  onPick: (row: DirectoryRow) => void;
}

export function DirectoryList({
  rows,
  highlightedIndex,
  onPick,
}: DirectoryListProps) {
  if (rows.length === 0) {
    return (
      <p className='px-3 py-6 text-center text-xs text-muted-foreground'>
        No matches
      </p>
    );
  }
  return (
    <ul className='flex-1 overflow-y-auto'>
      {rows.map((row, index) => (
        <li key={`${row.type}-${row.id}`}>
          <button
            type='button'
            onClick={() => onPick(row)}
            className={`flex w-full items-center gap-2 px-3 py-2 text-left text-sm hover:bg-muted ${
              index === highlightedIndex ? 'bg-muted' : ''
            }`}
          >
            {row.type === 'group' ? (
              <span className='flex h-7 w-7 items-center justify-center rounded-full bg-muted'>
                <Users className='h-3.5 w-3.5' />
              </span>
            ) : (
              <Avatar size='sm' initials={initialsOf(row.label)} />
            )}
            {row.label}
          </button>
        </li>
      ))}
    </ul>
  );
}
